module.exports = __webpack_public_path__ + "static/media/Artboard5.9c1e07ee.png";